import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose';

import { withRouter } from 'react-router-dom'
import { reduxForm } from 'redux-form'
import { SubmissionError } from 'redux-form'

import { withLoadingComponent, withErrorComponent } from '../components/loading';

import ResetPasswordForm from '../components/resetPassword';
import {resetPassword, checkToken} from '../store/actions/resetPassword';

const errors = (list) => {
    let e = list.filter(o => o.error);
    if(e.length > 0){
        return {error: e[0].error}
    }
    return {};
};

const mapStateToProps = (state, ownProps) => {
    return {
        ...state.token,
        ...errors([state.token, state.resetPassword ]),
        initialValues: {
            verificationToken: ownProps.match.params.token
        },
        strings: state.strings
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onSubmit: (data) => {
            if(data.password1.localeCompare(data.password2) !== 0)
                throw new SubmissionError({ password2: 'Passwords do not match'});

            dispatch(resetPassword(
                {verificationToken: data.verificationToken,
                    password: data.password1})
            ).then(r=>{
                ownProps.history.push(`/login`)
            }).catch(e=>{
                console.log("Error")
            })
        },
        checkToken: () => {
            dispatch(checkToken(ownProps.match.params.token))
        }
    }
};

const lifecycleValue = {
    componentWillMount() {
        this.props.checkToken();
    }
};

const formProps = {
    form: 'resetPassword'
};


export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    lifecycle(lifecycleValue),
    withErrorComponent,
    withLoadingComponent,
    reduxForm(formProps),
)(ResetPasswordForm);



// WEBPACK FOOTER //
// ./src/containers/ResetPasswordContainer.js